import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Mali"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.8",
  d: "M2.94555 4.05367L7.71867 8.25055C7.87977 8.39227 8.12102 8.39227 8.28211 8.25055L13.0552 4.05367C13.3509 3.79383 13.1671 3.30664 12.7737 3.30664H3.22727C2.83399 3.30664 2.65008 3.79383 2.94555 4.05367Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M13.6912 4.63017L8.56305 9.13923C8.2407 9.42267 7.7582 9.42267 7.43602 9.13923L2.30805 4.63017C2.03242 4.38751 1.59961 4.58345 1.59961 4.95048V11.8399C1.59961 12.3111 1.98164 12.6931 2.45289 12.6931H13.5462C14.0174 12.6931 14.3995 12.3111 14.3995 11.8399V4.95064C14.3996 4.58345 13.9668 4.38783 13.6912 4.63017Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var mali = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { mali as default };
